import React from 'react';
export function Footer() {
  return <footer className="bg-gray-800 text-white text-xs py-6 px-4 mt-auto" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="mb-4" data-id="element-87">
          <p className="mb-2" data-id="element-88">© 2025 Health Insider. All Rights Reserved.</p>
          <p className="text-gray-400" data-id="element-89">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
        </div>
        <div className="flex flex-wrap gap-4" data-id="element-90">
          <a href="#" className="text-gray-400 hover:text-white" data-id="element-91">
            Privacy Policy
          </a>
          <a href="#" className="text-gray-400 hover:text-white" data-id="element-92">
            Terms of Service
          </a>
          <a href="#" className="text-gray-400 hover:text-white" data-id="element-93">
            Contact Us
          </a>
        </div>
      </div>
    </footer>;
}